<template>
    <div class="content mb-2" style="max-height:600px; overflow-y: auto" v-cloak>
        <div class="md-layout">
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                <md-card>
                    <md-card-header data-background-color="blue">
                        <div class="btn-toolbar justify-content-between mb-0">
                            <div>
                                <h4 class="title">{{ $t('upcomingEvents.title') }}</h4>
                            </div>
                            <div>
                                <h4>
                                    <button class="btn btn-link m-0 p-0 mr-2"
                                            v-if="claims.upcomingEventsPanelDescription.read"
                                            @click.stop="showInfo=!showInfo"
                                            :title="$t('editor.common.description')">
                                        <i class="fas fa-question text-white"></i>
                                    </button>
                                    <button v-if="expanded" class="btn btn-link m-0 p-0" @click.stop="sizeToggle">
                                        <i class="fas fa-compress-arrows-alt text-white"></i>
                                    </button>
                                    <button v-else class="btn btn-link m-0 p-0" @click.stop="sizeToggle">
                                        <i class="fas fa-expand-arrows-alt text-white"></i>
                                    </button>
                                </h4>
                            </div>
                        </div>

                        <p class="category">{{ $t('upcomingEvents.description') }}</p>
                    </md-card-header>

                    <md-card-content>
                        <div  v-if="showInfo && claims.upcomingEventsPanelDescription.read" class="text-info radio-message-info mt-2">
                            <div>
                                <i class="fas fa-question mr-2"></i>
                                <strong>{{ $t("editor.common.description") }}</strong>
                            </div>
                            <div class="ml-3">
                                <ul>
                                    <li>{{ $t("upcomingEvents.help.upcomingEvent") }}</li>
                                    <li>{{ $t("upcomingEvents.help.subscriptionForEvent") }}</li>
                                    <li>{{ $t("upcomingEvents.help.subscriptionForEventEdit") }}</li>
                                    <li>{{ $t("upcomingEvents.help.notificationSubsciption") }}</li>
                                </ul>
                            </div>
                        </div>
                        <div v-cloak class="mb-2">
                            <div class="input-group col-sm-5 float-right">
                                <div class="input-group-addon fa fa-search"></div>
                                <input class="form-control" name="query" v-on:keyup.esc.stop="clearFilters" v-model="upcomingEventsSearchKey" />
                                <button class="btn btn-secondary"
                                        @click.stop="clearFilters">
                                    <i class="fas fa-times"></i>
                                    {{ $t('buttons.clear.btnText') }}
                                </button>
                            </div>
                        </div>

                        <div class="loader" v-if="loading"></div>
                        <div v-else>
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">{{$t('upcomingEvents.gridHeaders.name')}}</th>
                                        <th scope="col">{{$t('upcomingEvents.gridHeaders.contactPerson')}}</th>
                                        <th scope="col">{{$t('upcomingEvents.gridHeaders.audience')}}</th>
                                        <th scope="col">{{$t('upcomingEvents.gridHeaders.startTime')}}</th>
                                        <th scope="col">{{$t('upcomingEvents.gridHeaders.endTime')}}</th>
                                        <th scope="col">{{$t('upcomingEvents.gridHeaders.statuses')}}</th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in filteredData" :key="'myUpcomingEvents'+index" :id="'myUpcomingEvent'+ item.id">
                                        <th scope="row">{{index+1}}</th>
                                        <td>{{item.name}}</td>
                                        <td>{{item.eventContactPerson}}</td>
                                        <td>{{item.eventAudience}}</td>
                                        <td>{{item.startTimeUtc ? $moment(item.startTimeUtc).format('DD.MM.YYYY HH:mm') : ''}}</td>
                                        <td>{{item.endTimeUtc ? $moment(item.endTimeUtc).format('DD.MM.YYYY HH:mm') : ''}}</td>
                                        <td>{{item.statuses}}</td>
                                        <td>
                                            <span v-if="item.canSubscribe && item.canEditSubscriptionEntry" class="btn btn-link">
                                                <router-link :to="{ path: `/forms/complete?id=${item.subscriptionFormId}&returnUrl=${'/'}`}" replace :title="$t('upcomingEvents.completeSubsForm')" data-toggle="tooltip">
                                                    <i class="far fa-edit"></i>
                                                </router-link>
                                            </span>

                                            <span v-if="item.canSubscribe && !item.canEditSubscriptionEntry" class="btn btn-linkeditSubsForm">
                                                <router-link :to="{ path: `/forms/complete?id=${item.subscriptionFormId}&returnUrl=${'/'}`}" replace :title="$t('upcomingEvents.editSubsForm')" data-toggle="tooltip">
                                                    <i class="fab fa-wpforms"></i>
                                                </router-link>
                                            </span>

                                            <span v-if="item.canConfirmEventSubscriptionRequest">
                                                <button class="btn btn-link text-success" @click.stop="confirmEventSubscriptionRequest(item, $event)" :title="$t('upcomingEvents.participationRequestConfirmation')" data-toggle="tooltip">
                                                    <i class="fas fa-check"></i>
                                                </button>
                                            </span>

                                            <span v-if="item.canRejectEventSubscriptionRequest">
                                                <button class="btn btn-link text-danger" @click.stop="rejectEventSubscriptionRequest(item, $event)" :title="$t('upcomingEvents.participationRequestRejection')" data-toggle="tooltip">
                                                    <i class="fas fa-times"></i>
                                                </button>
                                            </span>

                                            <span v-if="claims.notificationSubscriptionWithActivationOfParticipationRequest.read && item.canSubscribeForEventNotification">
                                                <button class="btn btn-link text-success" @click.stop="subscribeForNotification(item, $event)" :title="$t('upcomingEvents.notificationSubsciption')" data-toggle="tooltip">
                                                    <i class="fas fa-comment"></i>
                                                </button>
                                            </span>

                                            <span v-if="claims.notificationSubscriptionWithActivationOfParticipationRequest.read && item.canUnsubscribeForEventNotification">
                                                <button class="btn btn-link text-danger" @click.stop="unsubscribeForNotification(item, $event)" :title="$t('upcomingEvents.notificationUnsubsciption')" data-toggle="tooltip">
                                                    <i class="fas fa-comment-slash"></i>
                                                </button>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </md-card-content>
                </md-card>
            </div>
        </div>

        <CreateModal :show="showCreate" :eventId="eventId" :eventName="eventName" @onCreate="onCreate" @onClose="onCreateClose"></CreateModal>
        <ConfirmationEditModal v-model="confirmationModel" :show="showConfirmation" @onCreate="onConfirmationCreate" @onClose="onConfirmationClose"></ConfirmationEditModal>
    </div>
</template>

<script>
    import { Role } from '@/helpers/role';
    import { UpcomingEvent, TempRankingToPersonModel } from '@/models/models'
    import eventService from '@/services/event.service';
    import tempRankingService from '@/services/tempRanking.service';
    import bus from '@/components/sidemenu/event-bus';

    import CreateModal from '@/components/dynamic/events/notificationSubscription/create.modal';
    import ConfirmationEditModal from "@/components/dynamic/events/accommodationRequest/edit.modal";
    import { mapGetters } from 'vuex';

    export default {
        components: {
            CreateModal,
            ConfirmationEditModal
        },
        props: {
            upcomingEventsExpanded: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                loading: false,
                expanded: this.upcomingEventsExpanded,
                upcomingEvents: [],
                showCreate: false,
                eventName: '',
                eventId: 0,
                upcomingEventsSearchKey: '',
                showConfirmation: false,
                confirmationModel: null,
                showInfo: false
            };
        },
        methods: {
            clearSource() {
                if (Array.isArray(this.upcomingEvents)) {
                    while (this.upcomingEvents.length > 0) {
                        this.upcomingEvents.pop();
                    }
                }
            },
            loadUpcomingEvents(focusElementId) {
                this.clearSource();
                this.loading = true;

                eventService.getUpcoming()
                    .then(response => {
                        this.loading = false;
                        if (response.data) {
                            response.data.forEach(obj => {
                                this.upcomingEvents.push(new UpcomingEvent(obj))
                            })

                            if (focusElementId) {
                                let el = document.getElementById(`myUpcomingEvent${focusElementId}`)
                                if (el) {
                                    el.focus()
                                }
                            }
                        }
                    })
                    .catch(error => {
                        this.loading = false;

                        this.$vs.notify({
                            title: this.$t(
                                'request.response.status.' +
                                this.$helpers.errorStatusCode(error)
                            ),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    })
            },
            confirmEventSubscriptionRequest(item, event) {
                this.confirmationModel = new TempRankingToPersonModel({
                    id: item.tempRankingId,
                    registerEntityId: item.id,
                    eventName: item.name,
                    eventStartDate: item.startTimeUtc,
                    eventEndDate: item.endTimeUtc
                });

                if (item.accommodationRequestRequired) {
                    this.showConfirmation = true;
                } else {
                    kendo
                        .confirm(this.$t('registers.events.evaluation.tempRanking.confirmConfirmation'))
                        .then(
                            function () {
                                tempRankingService.confirmTampRanking(this.confirmationModel)
                                    .then(response => {
                                        this.$emit("confirmed", this.confirmationModel)
                                        this.loadUpcomingEvents(item.id);

                                        this.$vs.notify({
                                            title: this.$t(
                                                'request.response.status.' +
                                                this.$helpers.responseStatusCode(response)),
                                            text: this.$helpers.responseMessage(
                                                response
                                            ),
                                            color: 'success',
                                            time: this.$store.getters.notificationDuration
                                        });
                                    })
                                    .catch(error => {
                                        this.$vs.notify({
                                            title: this.$t(
                                                'request.response.status.' +
                                                this.$helpers.errorStatusCode(error)
                                            ),
                                            text: this.$helpers.errorText(error),
                                            color: 'danger',
                                            time: this.$store.getters
                                                .notificationDuration
                                        });
                                    });
                            }.bind(this)
                        );
                }
            },
            rejectEventSubscriptionRequest(item, event) {
                kendo.prompt(`${this.$t('registers.events.evaluation.tempRanking.confirmRejection')}`, '')
                    .then(function (data) {
                        let model = new TempRankingToPersonModel({
                            id: item.tempRankingId,
                            registerEntityId: item.id,
                            eventName: item.name,
                            eventStartDate: item.startTimeUtc,
                            eventEndDate: item.endTimeUtc,
                            note: data
                        });

                        tempRankingService.rejectTampRanking(model)
                            .then(response => {
                                this.$emit("rejected", model)
                                this.loadUpcomingEvents(item.id);

                                this.$vs.notify({
                                    title: this.$t(
                                        'request.response.status.' +
                                        this.$helpers.responseStatusCode(response)),
                                    text: this.$helpers.responseMessage(
                                        response
                                    ),
                                    color: 'success',
                                    time: this.$store.getters.notificationDuration
                                });
                            })
                            .catch(error => {
                                this.$vs.notify({
                                    title: this.$t(
                                        'request.response.status.' +
                                        this.$helpers.errorStatusCode(error)
                                    ),
                                    text: this.$helpers.errorText(error),
                                    color: 'danger',
                                    time: this.$store.getters
                                        .notificationDuration
                                });
                            });
                    }.bind(this));
            },
            subscribeForNotification(item, event) {
                this.eventName = item.name;
                this.eventId = item.id;
                this.showCreate = true;
            },
            unsubscribeForNotification(item, event) {
                kendo.confirm(this.$t('upcomingEvents.confirmations.notificationUnsubsciption'))
                    .then(function () {
                        this.doUnsubscribeForNotification(item);
                    }.bind(this));
            },
            doUnsubscribeForNotification(item) {
                eventService.unsubscribeForEventNotification(item.id)
                    .then(response => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                        let event = this.upcomingEvents.find(element => element.id === item.id);
                        if (event) {
                            event.canUnsubscribeForEventNotification = false;
                            event.canSubscribeForEventNotification = true;
                        }
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t(
                                'request.response.status.' +
                                this.$helpers.errorStatusCode(error)
                            ),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    })
            },
            sizeToggle() {
                this.expanded = !this.expanded;
                this.$emit('sizeToggle')
            },
            onCreateClose() {
                this.showCreate = false;
                this.eventName = '';
                this.eventId = 0;
            },
            onCreate(model) {
                this.showCreate = false;
                this.eventName = '';
                this.eventId = 0;

                let event = this.upcomingEvents.find(element => element.id === model.eventId);
                if (event) {
                    event.canSubscribeForEventNotification = false;
                    event.canUnsubscribeForEventNotification = true;
                }
            },
            onConfirmationCreate(model) {
                this.$emit("confirmed", model)
                this.loadUpcomingEvents(model.registerEntityId);
            },
            onConfirmationClose() {
                this.showConfirmation = false;
                this.confirmationModel = null;
            },
            clearFilters() {
                this.upcomingEventsSearchKey = '';
            },
            reload() {
                this.loadUpcomingEvents();
            },
            onEventAdded(id, eventName, eventCode) {
                this.reload();
            },
            onEventUpdated(id, eventName, eventCode) {
                this.reload();
            },
        },
        mounted() {
            this.loadUpcomingEvents();

            var container = $(this.$el);
            container.find('[data-toggle="tooltip"]').tooltip({ container });
        },
        computed: {
            ...mapGetters(['claims', 'userRoles', 'isEnVersion']),
            isNew() {
                return isNaN(this.id) || this.id === undefined || this.id === 0;
            },
            filteredData() {
                var filterKey = this.upcomingEventsSearchKey && this.upcomingEventsSearchKey.toLowerCase();
                var data = this.upcomingEvents;
                if (filterKey) {
                    data = data.filter(function (row) {
                        return Object.keys(row).some(function (key) {
                            return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
                        });
                    });
                }

                return data;
            },
            hasInfoReadRights() {
                return this.userRoles.includes(Role.Coordinator)
                || this.userRoles.includes(Role.Admin)
                || this.userRoles.includes(Role.EventAdmin)
                || this.userRoles.includes(Role.SuperAdmin);
            }
        },
        created() {
            this.bus = bus;

            this.bus.$on('event-addded', this.onEventAdded);
            this.bus.$on('event-updated', this.onEventUpdated);
            this.bus.$on('event-deleted', this.onEventUpdated);
        },
        beforeDestroy() {
            // Make sure to cleanup SignalR event handlers when removing the component
            this.bus.$off('event-addded', this.onEventAdded);
            this.bus.$off('event-updated', this.onEventUpdated);
            this.bus.$off('event-deleted', this.onEventUpdated);
        },
    };
</script>

<style scoped>
</style>
